import React from 'react';
import { Paper, TextField, makeStyles } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { ReactComponent as ArrowDown } from './less.svg';
import styled from 'styled-components';

export type Option<V, L> = {
  value: V;
  label: L;
};

interface SelectWithSearchingProps<V, L> {
  value: Option<V, L> | null;
  options: Option<V, L>[];
  placeholder: string;
  noOptionsText: string;
  onChange: (value: Option<V, L>) => void;
  defaultValue?: Option<V, L>;
  'data-qa-id'?: string;
}

const useStyles = makeStyles({
  endAdornment: {
    top: '7px',
    right: '2px',
  },
  popupIndicator: {
    padding: '4px',
    margin: '0px',
  },
});

const Icon = styled(ArrowDown)`
  transform: rotate(180deg);
`;

const SelectWithSearching = <V, L extends string>(props: SelectWithSearchingProps<V, L>) => {
  const style = useStyles();
  const handleChange = (e: React.ChangeEvent<{}>, selectedOption: Option<V, L>) => {
    props.onChange(selectedOption);
  };
  return (
    <Autocomplete
      value={props.value as Option<V, L>}
      onChange={handleChange}
      options={props.options}
      getOptionSelected={(option, value) => value.value === option.value}
      renderInput={(params) => <TextField {...params} placeholder={props.placeholder} />}
      getOptionLabel={(option) => option.label}
      disableClearable
      popupIcon={<Icon />}
      classes={style}
      noOptionsText={props.noOptionsText || 'Нет доступных вариантов'}
      data-qa-id={props['data-qa-id']}
    />
  );
};

export default SelectWithSearching;
